import http from '../../../utils/fetch';
export default {
    showJD() {
        return http({
            url: '/api/swyl/v1/demo/loudProduct/showJD',
            method: 'post',
        });
    },
    showProduct(query) {
        return http({
            url: '/api/swyl/v1/demo/loudProduct/showProduct',
            method: 'post',
            params: query
        });
    },
}